import { throttle } from 'lodash-es';
import { onMounted, onBeforeUnmount, ref } from 'vue';

type ScrollUpPositionOptions = {
    threshold?: number;
    throttleDelay?: number;
};

const defaultOptions: ScrollUpPositionOptions = {
    threshold: 500,
    throttleDelay: 500
};

export default function useScrollUpPosition(
    opts: ScrollUpPositionOptions = defaultOptions
) {
    const { threshold, throttleDelay } = { ...defaultOptions, ...opts };
    const visible = ref(false);

    const scrollListener = () => {
        visible.value = window.scrollY > threshold;
    };

    onMounted(() => {
        if (typeof window === 'undefined') {
            return;
        }
        const throttledScrollListener = throttle(scrollListener, throttleDelay);
        window.addEventListener('scroll', throttledScrollListener);

        onBeforeUnmount(() => {
            window.removeEventListener('scroll', throttledScrollListener);
        });
    });

    return { visible };
}
